module.exports = __webpack_public_path__ + "img/register-family-btn.cb089646.png";